import { NodeParamsConfig, ParamTemplate } from "../params/ParamsConfig";
export class PolyNodeParamsConfig {
  static ParamsConfig(data, paramsConfig = new NodeParamsConfig()) {
    if (data.params) {
      for (let paramData of data.params) {
        const paramName = paramData.name;
        const paramType = paramData.type;
        const initValue = paramData.initValue;
        const options = paramData.options;
        paramsConfig[paramName] = new ParamTemplate(paramType, initValue, options);
      }
    }
    return paramsConfig;
  }
}
